import { Service } from "services/Service";
import logo from "assets/image/logo.png";
import Util from "services/Util";
import { applyScreenshotPolicy, isScreenshotAllowedFlag } from "utils/screenshotGuard";

export const CONFIG_KEY = "@beedooconfigkey";

export const getDefaultObject = ()=> {
  return {
    color1: '#eec316',
    color2: '#e77e24',
    colorDisabled: '#999',
    logo
  };
};

export const mergeDefaultConfig = (configObj, defaultObj)=> {
  Object.keys(defaultObj).forEach(def=> configObj[def] = configObj[def] || defaultObj[def]);
  return configObj;
};

function applyScreenshotPolicyFromConfig(config) {
  applyScreenshotPolicy(isScreenshotAllowedFlag(config?.allowScreenshot));
}

export const getConfig = async (forceRefresh = false) => {
  try {
    if (!forceRefresh && JSON.parse(localStorage.getItem(CONFIG_KEY))) {
      const cachedConfig = JSON.parse(localStorage.getItem(CONFIG_KEY));
      applyScreenshotPolicyFromConfig(cachedConfig);
      return cachedConfig;
    }
    const service = new Service();
    const util = new Util();
    const res = await service.getWaiting( "/team/"+util.getSubDomain() );
    if (!res || !res.team) {
      const defaultConfig = getDefaultObject();
      applyScreenshotPolicyFromConfig(defaultConfig);
      return defaultConfig;
    }

    const config = mergeDefaultConfig(res.team, getDefaultObject());
    localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
    applyScreenshotPolicyFromConfig(config);
    return config;
  } catch (error) {
    const defaultConfig = getDefaultObject();
    applyScreenshotPolicyFromConfig(defaultConfig);
    return defaultConfig;
  }
};

export function getConfigSync() {
  if (JSON.parse(localStorage.getItem(CONFIG_KEY))) {
    return JSON.parse(localStorage.getItem(CONFIG_KEY))
  } 
  return getDefaultObject();
}

export const getVisualIdentity = () => {
  try {
    return JSON.parse(localStorage.getItem("VISUAL_IDENTITY"));
  } catch (error) {
    console.error(error);
  }
};

